import moment from 'moment';

// @ts-check

/** @type {import('./types/reports.types').ReportsContent} */
const fuel = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          {
            field: 'no',
            header: 'No.',
          },
          {
            field: 'assetName',
            header: 'Asset',
          },
          {
            field: 'refuelCount',
            header: 'Refuel Count',
          },
          {
            field: 'refuelVolume',
            header: 'Refuel Volume',
          },
          {
            field: 'refuelWeight',
            visible: false,
            header: 'Refuel Weight',
          },
          {
            field: 'refuelPrice',
            header: 'Refuel Amount (RM)',
          },
          {
            field: 'runConsumption',
            header: 'Run Consumption',
          },
          {
            field: 'distanceTravelled',
            header: 'Distance Travelled',
          },
          {
            field: 'literper100km',
            header: 'L/100KM',
          },
          {
            field: 'literperkm',
            header: 'L/KM',
          },
          {
            field: 'kmperliter',
            header: 'KM/L',
          },
          {
            header: 'Actions',
            template: {
              component: 'ActionButtons',
              data: [
                {
                  text: 'View Fuel Chart',
                  icon: 'icon-bar-chart',
                  iconPack: 'feather',
                  click: {
                    component: 'FuelChart',
                    data: { onReady: getChart },
                  },
                },
                {
                  text: 'View Refuel Breakdown',
                  icon: 'local_gas_station',
                  click: {
                    component: 'ModalTable',
                    data: { onReady: getRefuel },
                  },
                },
              ],
            },
          },
        ],
      },
      pdf: {
        title: 'Fuel - Summary',
        colsWidth: [20, 80, 55, 55, 55],
      },
    },
    {
      label: 'Refuels',
      icon: 'local_gas_station',
      view: {
        type: 'table',
        content: RefuelsContent,
      },
      pdf: {
        title: 'Fuel - Refuels',
        colsWidth: [80, 80, 55, 55, 55, 50, 55, 55, 55, 50, 120, 80, 80],
        beforeGenerate: (self) => {
          self.reportData.forEach((e, i) => {
            let arr = [];
            if (e.receipt) {
              if (Array.isArray(e.receipt)) {
                e.receipt.forEach((r) => {
                  arr.push(`${r.fuel.toFixed(1)} Ltr`);
                });
              } else {
                arr.push(e.receipt);
              }
              // self.pdfReportData[i].receipt;
            }
            self.pdfReportData[i].receipt = arr.join('\n');
          });
        },
      },
    },
    {
      label: 'Abnormal Consumption',
      icon: 'warning',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          {
            field: 'siphonTime',
            header: 'Time',
          },
          {
            field: 'siphonVolumeBefore',
            header: 'Before Consumption',
          },
          {
            field: 'siphonVolumeAfter',
            header: 'After Consumption',
          },
          {
            field: 'siphonVolume',
            header: 'Consumption Volume',
          },
          {
            field: 'siphonWeight',
            header: 'Consumption Weight',
          },
          {
            field: 'mileageAtSiphon',
            header: 'Mileage',
          },
          {
            field: 'address',
            header: 'Location',
          },
          {
            field: 'coordinates',
            header: 'Coordinates',
            template: { component: 'GoogleMapLink' },
          },
        ],
      },
      pdf: { title: 'Fuel Abnormal Consumption', colsWidth: [50, 80] },
    },
  ];
};

const RefuelsContent = [
  { field: 'assetName', header: 'Asset' },
  {
    field: 'refuelTime',
    header: 'Time',
  },
  {
    field: 'refuelVolumeBefore',
    header: 'Before Refuel',
  },
  {
    field: 'refuelVolumeAfter',
    header: 'After Refuel',
  },
  {
    field: 'refuelVolume',
    header: 'Refuel Volume',
  },
  {
    field: 'refuelWeight',
    header: 'Refuel Weight',
    visible: false,
  },
  {
    field: 'fuelPrice',
    header: 'Fuel Price (RM)',
  },
  {
    field: 'refuelPrice',
    header: 'Refuel Amount (RM)',
  },
  {
    field: 'receipt',
    header: 'Receipt',
    template: {
      component: 'ActionButtons',
      data: (row) => {
        let arr = [];
        if (Array.isArray(row.receipt)) {
          row.receipt.forEach((e) => {
            let obj = {
              text: `${e.fuel.toFixed(1)} Ltr`,
              showText: true,
              click: {
                component: 'ViewReceipt',
                data: {
                  onReady: getFuelReceipts,
                },
              },
            };
            arr.push(obj);
          });
          return arr;
        } else {
          return [
            {
              text: row.receipt,
              showText: true,
            },
          ];
        }
      },
    },
    hideTooltip: true,
  },
  {
    field: 'receiptTotalVolume',
    header: 'Receipt Total - Volume',
    visible: false,
  },
  {
    field: 'receiptTotalPrice',
    header: 'Receipt Total - Price',
    visible: false,
  },
  {
    field: 'receiptDifferenceVolume',
    header: 'Receipt Difference - Volume',
    visible: false,
  },
  {
    field: 'receiptDifferencePrice',
    header: 'Receipt Difference - Price',
    visible: false,
  },
  {
    field: 'receiptDifferencePct',
    header: 'Receipt Difference - %',
    visible: false,
  },
  {
    field: 'mileageAtRefuel',
    header: 'Mileage',
  },
  {
    field: 'address',
    header: 'Location',
  },
  {
    field: 'coordinates',
    header: 'Coordinates',
    template: { component: 'GoogleMapLink' },
  },
  {
    header: 'Actions',
    template: {
      component: 'ActionButtons',
      data: [
        {
          text: 'Add Fuel Receipt',
          icon: 'icon-plus-square',
          iconPack: 'feather',
          click: {
            component: 'AddFuelReceipt',
            data: {
              onReady: async (self) => {
                return new Promise((resolve) => {
                  let args = self.data.rowData;
                  self.dt = args;
                  resolve(true);
                });
              },
            },
          },
        },
      ],
    },
  },
];

const getChart = async (
  self,
  { url = 'refuelChart', isSpikeChart = false } = {},
) => {
  let args = self.data.rowData;
  return new Promise((resolve, reject) => {
    // {
    self.selected.assetName = args.assetName;
    self.selected.assetId = args.assetId;
    var timeRange = isSpikeChart ? parseDateRange(args.time) : self.timeRange;
    self.$http
      .post(
        `${url}/ ` + args.assetId + '/' + self.userInfo.uid + '/' + args.unitId,
        {
          timeRange: timeRange,
        },
      )
      .then(function (response) {
        if (response.status == 200 && response.data.success) {
          const data = response.data.series;
          self.dataSource = {
            data: null,
            navigator: {
              enabled: 0,
            },
            extensions: {
              customRangeSelector: {
                enabled: 0,
              },
            },
            chart: {
              animation: 0,
              palettecolors: 'FF0000,0000FF,008000',
              multicanvas: false,
              exportEnabled: 1,
              exportFileName: 'Fuel Chart - ' + args.assetName,
            },
            caption: {
              text:
                'Fuel Chart - ' +
                args.assetName +
                ' (' +
                moment(self.timeRange[0]).format('D/M/YYYY | HH:mm:ss') +
                ' - ' +
                moment(self.timeRange[1]).format('D/M/YYYY | HH:mm:ss') +
                ')',
            },
            datamarker: null,
            yaxis: [
              {
                min: 0,
                plot: [
                  {
                    value: 'Fuel',
                    connectnulldata: true,
                    type: 'line',
                  },
                ],
                format: {
                  suffix: ' litres',
                },
              },
              {
                plot: [
                  {
                    value: 'Odometer',
                    connectnulldata: true,
                    type: 'line',
                  },
                ],
                format: {
                  suffix: ' km',
                },
              },
              {
                min: 0,
                max: 200,
                plot: [
                  {
                    value: 'Speed',
                    connectnulldata: true,
                    type: 'line',
                  },
                ],
                format: {
                  suffix: ' kph',
                },
              },
            ],
          };
          //  self.dataSource.datamarker =response.data.datamarker;
          self.onReadyData = {};
          self.onReadyData.title = self.dataSource.chart.exportFileName;
          const dataSchema = response.data.dataSchema;
          if (response.data.type == 2) {
            self.dataSource.chart.palettecolors = 'FF0000,FFD700,0000FF,008000';
            self.dataSource.yaxis = [
              {
                min: 0,
                plot: [
                  {
                    value: 'Fuel',
                    connectnulldata: true,
                    type: 'line',
                  },
                ],
                format: {
                  suffix: ' litres',
                },
              },
              {
                min: 0,
                plot: [
                  {
                    value: 'Fuel2',
                    connectnulldata: true,
                    type: 'line',
                  },
                ],
                format: {
                  suffix: ' litres',
                },
              },
              {
                plot: [
                  {
                    value: 'Odometer',
                    connectnulldata: true,
                    type: 'line',
                  },
                ],
                format: {
                  suffix: ' km',
                },
              },
              {
                min: 0,
                max: 200,
                plot: [
                  {
                    value: 'Speed',
                    connectnulldata: true,
                    type: 'line',
                  },
                ],
                format: {
                  suffix: ' kph',
                },
              },
            ];
          }

          resolve({ data, dataSchema });
        } else {
          resolve(false);
        }
      })
      .catch(function (error) {
        reject(error);
        // console.log(error);
      });
    // }
  });
};

function parseDateRange(input) {
  // Split the string into start and end parts
  const [start, end] = input.split(' - ');

  // Parse the date and time components
  const parseDate = (dateTime) => {
    const [date, time] = dateTime.split(' | ');
    const [day, month, year] = date.split('/').map(Number);
    const [hours, minutes, seconds] = time.split(':').map(Number);

    // Create the date object and adjust for GMT+8 to UTC
    return new Date(
      Date.UTC(year, month - 1, day, hours - 8, minutes, seconds),
    );
  };

  // Get start and end dates as UTC
  const startDate = parseDate(start);
  const endDate = parseDate(end);

  // Adjust the end date to include the full day in UTC
  // endDate.setUTCHours(23, 59, 59, 999);

  // Return the formatted result
  return [startDate.toISOString(), endDate.toISOString()];
}

const getRefuel = async (self) => {
  let args = self.data.rowData;
  let modal = JSON.parse(JSON.stringify(self.modalTableApi));
  return new Promise((resolve) => {
    if (args.refuelVolume == 0) {
      self.$vs.notify({
        title: 'Error',
        text: 'No data available',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
      });
      resolve(false);
    } else if (args.refuelVolume != 0) {
      self.$http
        .post('reports-utils/getIndividualFuelBreakdown', {
          timeRange: self.timeRange,
          uid: self.userInfo.uid,
          unitId: args.unitId,
          assetId: args.assetId,
          assetName: args.assetName,
          geoPOIData: self.geoPOIData,
          refuelVolume: self.refuelVolume,
          refuelTimer: self.refuelTimer,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            let breakdownData = [];
            breakdownData.push({
              assetId: args.assetId,
              type: 'Refuel',
              assetName: args.assetName,
              arr: response.data.singleRefuelArray,
            });
            breakdownData[0].arr.forEach((e) => {
              modal.reportData.push(e);
            });
            modal.title = `Refuel - ${args.assetName}`;
            modal.pdf.title = modal.title;
            // let fuel = fuel();
            modal.table.content = JSON.parse(JSON.stringify(RefuelsContent));
            modal.table.content.forEach((e) => {
              if (e.header == 'Coordinates') {
                e.template.data = { component: 'GoogleMapEmbed' };
              }
            });
            modal.table.content[8] = {
              field: 'receipt',
              header: 'Receipt',
              template: {
                component: 'ActionButtons',
                data: (row) => {
                  let arr = [];
                  if (Array.isArray(row.receipt)) {
                    row.receipt.forEach((e) => {
                      let obj = {
                        text: `${e.fuel.toFixed(1)} Ltr`,
                        showText: true,
                        click: {
                          modal: (that) => {
                            that.colClick({
                              component: 'ViewReceipt',
                              data: {
                                rowData: that.rowData,
                                templateData: that.templateData,
                                data: {
                                  onReady: getFuelReceipts,
                                },
                              },
                            });
                          },
                        },
                      };
                      arr.push(obj);
                    });
                    return arr;
                  } else {
                    return [
                      {
                        text: row.receipt,
                        showText: true,
                      },
                    ];
                  }
                },
              },
            };
            modal.pdf.colsWidth = [
              80, 80, 55, 55, 55, 50, 55, 55, 55, 50, 120, 80,
            ];
            modal.pdf.beforeGenerate = (that) => {
              that.reportData.forEach((e, i) => {
                let arr = [];
                if (e.receipt) {
                  if (Array.isArray(e.receipt)) {
                    e.receipt.forEach((r) => {
                      arr.push(`${r.fuel.toFixed(1)} Ltr`);
                    });
                  } else {
                    arr.push(e.receipt);
                  }
                }
                that.pdfReportData[i].receipt = arr.join('\n');
              });
            };
            self.onReadyData = modal;
            resolve(true);
          } else {
            if (response.data.error) {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
              resolve(false);
            } else {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
              resolve(false);
            }
          }
        })
        .catch(function (error) {
          console.log(error);

          self.$vs.notify({
            title: 'Error',
            text: 'Try again later.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
          resolve(false);
        });
    }
  });
};

const getFuelReceipts = async (self) => {
  return new Promise((resolve) => {
    let args = self.data.rowData.receipt;
    self.loadedReceipts = [];
    self.isLoading = true;
    self.$http
      .post('receiptsMultiple', {
        receipts: args,
      })
      .then(function (response) {
        self.isLoading = false;
        if (response.status == 200 && response.data.success) {
          self.loadedReceipts = response.data.receiptDetails;
          // self.popupActive3 = true;
          self.upload = false;
          resolve(true);
        } else {
          self.isLoading = false;
          if (response.data.error) {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          } else {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          }
        }
      })
      .catch(function (error) {
        self.isLoading = false;

        self.$vs.notify({
          title: 'Error',
          text: 'Try again later.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        resolve(false);
      });
  });
};
export { fuel, getChart };
